import { CardComponentProps } from "../types/types";
import * as components from "./";
import React from "react";

type StandardComponent = (
  props: CardComponentProps & { sizes?: string },
) => React.ReactNode;

type ComponentMap = { [name: string]: StandardComponent };

export const componentMap: ComponentMap = components;
